import { render, staticRenderFns } from "./OtpLogin.vue?vue&type=template&id=62012038&scoped=true"
import script from "./OtpLogin.vue?vue&type=script&lang=js"
export * from "./OtpLogin.vue?vue&type=script&lang=js"
import style0 from "./OtpLogin.vue?vue&type=style&index=0&id=62012038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62012038",
  null
  
)

export default component.exports